import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center p-6 gap-8">
      {/* Wordmark */}
      <div className="flex flex-col items-center gap-1 select-none">
        <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center shadow-sm">
          <span className="font-display font-bold text-2xl text-white tracking-tight">P</span>
        </div>
        <span className="font-display font-bold text-xl text-ink tracking-tight mt-1">Proclaim</span>
        <span className="text-ink-muted text-sm text-center max-w-xs">
          Presentaciones bíblicas para tu iglesia
        </span>
      </div>

      {/* Clerk component */}
      {children}
    </div>
  );
}
